module.exports = __webpack_public_path__ + "img/button-group-light-01.36378e7b.png";